import { Component } from "@angular/core";
import { ColDef, GridApi } from "ag-grid";
import { LocationInfo } from "../../services/consults.service";
import { AgOverlayTemplate } from "../../components/ag-grid/ag-overlay-template";
import { ScheduleService, Line, ScheduleByLocation, AlertService } from "../../services";

@Component({
  selector: 'schedule-date',
  templateUrl: 'schedule-date.html'
})
export class ScheduleByDate {

  orgLocation:LocationInfo;
  desLocation:LocationInfo;

  scheduleByLocation: Array<ScheduleByLocation> = [];
  locationColDef: ColDef[] = [
    {
      headerName: '선사',
      field: 'shprCd',
      editable: false,
      width: 100
    },
    {
      headerName: '출발지',
      field: 'depLocationId',
      editable: false,
      width: 200
    },
    {
      headerName: '도착지',
      field: 'arrLocationId',
      editable: false,
      width: 200
    },
    {
      headerName: '스케줄 총량',
      field: 'cntSchedule',
      editable: false,
      width: 100
    },
    {
      headerName: '가장 오래된 날짜',
      field: 'regDate',
      editable: false,
      width: 150
    }
  ];
  frameworkCompsLocation;

  
  gridLocationApi: GridApi;

  overlayLoadingTemplate = AgOverlayTemplate.overlayProcessingTemplate;

  selectedLine:Line;
  scheduleByLine: Array<any> = [];
  lineColDef:ColDef[] = [
    {
      headerName: '출발지',
      field: 'depLocationId',
      editable: false,
      width: 200
    },
    {
      headerName: '출발지',
      field: 'depLocationName',
      editable: false,
      width: 200
    },
    {
      headerName: '도착지',
      field: 'arrLocationId',
      editable: false,
      width: 200
    },
    {
      headerName: '도착지',
      field: 'arrLocationName',
      editable: false,
      width: 200
    },
    {
      headerName: '데이터 유무',
      field: 'dataYn',
      editable: false,
      width: 100
    },
    {
      headerName: '업데이트 된 날짜',
      field: 'updateDate',
      editable: false,
      width: 150
    }
  ]
  frameworkCompsLine;

  gridLineApi: GridApi;

  constructor(private scheduleService: ScheduleService, private alertService: AlertService) {

  }


  onGridLocationReady(params) {
    this.gridLocationApi = params.api;
    this.gridLocationApi.sizeColumnsToFit();
  }

  orgPortSelected(event) {
    this.orgLocation = event;
  }

  desPortSelected(event) {
    this.desLocation = event;
  }

  getScheduleByLocation() {
    if(this.orgLocation && this.orgLocation.locationId && this.desLocation && this.desLocation.locationId) {
      this.gridLocationApi.showLoadingOverlay();
    this.scheduleService.getScheduleByLocation(this.orgLocation.locationId, this.desLocation.locationId, resp => {
      if(resp) {
        this.scheduleByLocation = resp;
        this.gridLocationApi.sizeColumnsToFit();
        this.gridLocationApi.hideOverlay();
      }
    });
    } else {
      this.alertService.error("출발지-도착지 선택은 필수입니다.");
      return;
    }
    
  }

  onGridLineReady(params) {
    this.gridLineApi = params.api;
    this.gridLineApi.sizeColumnsToFit();
  }

  selectLine(event) {
    this.selectedLine = event;
  }

  getScheduleByLine() {
    if(this.selectedLine && this.selectedLine.lineCd) {
      this.gridLineApi.showLoadingOverlay();
      this.scheduleService.getScheduleByLine(this.selectedLine.lineCd, resp => {
        if(resp) {
          this.scheduleByLine = resp;
          this.gridLineApi.sizeColumnsToFit();
          this.gridLineApi.hideOverlay();
        }
      });
    } else {
      this.alertService.error("선사 선택은 필수입니다.");
      return;
    }
    
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/schedule/schedule-date.ts